/**
 * Frontend environment configuration.
 *
 * Single source of truth for the backend URL used by api.js
 * and any other module that needs it.
 *
 * Resolution order:
 *   1. REACT_APP_API_URL env var (set at build time)
 *   2. Production default (when running on a deployed domain)
 *   3. Localhost fallback (when running on localhost)
 */

const PROD_API_URL = 'https://indexingapi.aibrokerhub.com';

export const API_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:8001'
    : PROD_API_URL);

export const IS_DEV = window.location.hostname === 'localhost';
